/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Failed_GenericInputs */

const en_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error exporting audio description`)
};

const fr_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'exportation de la description audio`)
};

const de_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Audiobeschreibung`)
};

const it_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante l'esportazione della descrizione audio`)
};

const ru_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при экспорте аудиоописания`)
};

const es_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al exportar la descripción de audio`)
};

const zh_cn2_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出音频描述时出错`)
};

const ja_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声説明のエクスポート中にエラーが発生しました`)
};

const hi_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात करने में त्रुटि`)
};

const pt_pt2_audio_description_export_failed_generic = /** @type {(inputs: Audio_Description_Export_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao exportar a descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Error exporting audio description" |
*
* @param {Audio_Description_Export_Failed_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_failed_generic = /** @type {((inputs?: Audio_Description_Export_Failed_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Failed_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_failed_generic(inputs)
	if (locale === "de") return de_audio_description_export_failed_generic(inputs)
	if (locale === "it") return it_audio_description_export_failed_generic(inputs)
	if (locale === "ru") return ru_audio_description_export_failed_generic(inputs)
	if (locale === "es") return es_audio_description_export_failed_generic(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_failed_generic(inputs)
	if (locale === "ja") return ja_audio_description_export_failed_generic(inputs)
	if (locale === "hi") return hi_audio_description_export_failed_generic(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_failed_generic(inputs)
	return en_audio_description_export_failed_generic(inputs)
});